<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <path fill="#E1F5FE" d="M29.23 2.875l-.001 22.041h6.709v11.021h-6.71l.001.48H9.583v-23.48H2.396V2.876h26.833z" transform="translate(-593 -329) translate(556 292) translate(37 37) translate(3.833 3.833)" />
              <path
                fill="#164194"
                d="M35.139 33.542c0 .883-.716 1.598-1.597 1.598H15.975v-9.583H35.14v7.985zm-22.358 0c0 .883-.718 1.598-1.597 1.598h-.004c-.882 0-1.597-.715-1.597-1.596V3.194h17.57c.883 0 1.597.715 1.597 1.598v17.57H12.78v11.18zM6.389 12.778H3.195V4.792c0-.883.714-1.598 1.597-1.598s1.597.715 1.597 1.598v7.986zm25.556 9.584V4.792C31.945 2.146 29.799 0 27.153 0H4.792C2.146 0 0 2.145 0 4.792v11.18h6.389v17.571c0 2.646 2.145 4.792 4.791 4.79h22.362c2.645 0 4.791-2.145 4.791-4.79V22.362h-6.388z"
                transform="translate(-593 -329) translate(556 292) translate(37 37) translate(3.833 3.833)"
              />
              <path fill="#13A2E8" d="M31.945 28.752v3.194H19.167v-3.194h12.778zm-6.39-15.974v3.195H12.778v-3.195h12.777zm0-6.39v3.195H12.778V6.39h12.777z" transform="translate(-593 -329) translate(556 292) translate(37 37) translate(3.833 3.833)" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>